import {LISTING_SECTION_IDS} from '../listingSections.js'

export const OFFER_TYPES_IDS = {
  SECOND_HAND: '0',
  NEW: '1',
  KM0: '2',
  SUBSTITUTION: '3',
  MANAGEMENT: '4',
  DEMONSTRATION: '5',
  RENTAL: '7',
  PRE_OWNED: '8',
  SUBSCRIPTION: '10',
  UNSELECTED: '-1'
}

export const OFFER_TYPES = {
  [OFFER_TYPES_IDS.SECOND_HAND]: {
    id: OFFER_TYPES_IDS.SECOND_HAND,
    name: 'COMMON.OFFER_TYPE.SECOND_HAND'
  },
  [OFFER_TYPES_IDS.NEW]: {
    id: OFFER_TYPES_IDS.NEW,
    name: 'COMMON.OFFER_TYPE.NEW'
  },
  [OFFER_TYPES_IDS.KM0]: {
    id: OFFER_TYPES_IDS.KM0,
    name: 'COMMON.OFFER_TYPE.KM0'
  },
  [OFFER_TYPES_IDS.SUBSTITUTION]: {
    id: OFFER_TYPES_IDS.SUBSTITUTION,
    name: 'COMMON.OFFER_TYPE.SUBSTITUTION'
  },
  [OFFER_TYPES_IDS.MANAGEMENT]: {
    id: OFFER_TYPES_IDS.MANAGEMENT,
    name: 'COMMON.OFFER_TYPE.MANAGEMENT'
  },
  [OFFER_TYPES_IDS.DEMONSTRATION]: {
    id: OFFER_TYPES_IDS.DEMONSTRATION,
    name: 'COMMON.OFFER_TYPE.DEMONSTRATION'
  },
  [OFFER_TYPES_IDS.RENTAL]: {
    id: OFFER_TYPES_IDS.RENTAL,
    name: 'COMMON.OFFER_TYPE.RENTAL'
  },
  [OFFER_TYPES_IDS.PRE_OWNED]: {
    id: OFFER_TYPES_IDS.PRE_OWNED,
    name: 'COMMON.OFFER_TYPE.PRE_OWNED'
  },
  [OFFER_TYPES_IDS.SUBSCRIPTION]: {
    id: OFFER_TYPES_IDS.SUBSCRIPTION,
    name: 'COMMON.OFFER_TYPE.SUBSCRIPTION'
  }
}

export const DEFAULT_OFFER_TYPE_ID_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: OFFER_TYPES_IDS.UNSELECTED,
  [LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.BUGGIES_NEW_VEHICLES]: OFFER_TYPES_IDS.NEW,
  [LISTING_SECTION_IDS.BUGGIES_SECOND_HAND_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.BUGGIES_VEHICLES]: OFFER_TYPES_IDS.UNSELECTED,
  [LISTING_SECTION_IDS.CLASSIC_AND_COMPETITION_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.CLASSIC_MOTOS_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.KM0_VEHICLES]: OFFER_TYPES_IDS.KM0,
  [LISTING_SECTION_IDS.MINIMOTOS_NEW_VEHICLES]: OFFER_TYPES_IDS.NEW,
  [LISTING_SECTION_IDS.MINIMOTOS_SECOND_HAND_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.MINIMOTOS_VEHICLES]: OFFER_TYPES_IDS.UNSELECTED,
  [LISTING_SECTION_IDS.NEW_VEHICLES]: OFFER_TYPES_IDS.NEW,
  [LISTING_SECTION_IDS.NO_LICENSE_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_NEW_VEHICLES]: OFFER_TYPES_IDS.NEW,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_SECOND_HAND_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_VEHICLES]: OFFER_TYPES_IDS.UNSELECTED,
  [LISTING_SECTION_IDS.RENTING_VEHICLES]: OFFER_TYPES_IDS.SUBSCRIPTION,
  [LISTING_SECTION_IDS.SECOND_HAND_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND,
  [LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES]: OFFER_TYPES_IDS.SECOND_HAND
}

export const DEFAULT_REQUEST_OFFER_TYPE_IDS_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: [
    OFFER_TYPES_IDS.SECOND_HAND,
    OFFER_TYPES_IDS.NEW,
    OFFER_TYPES_IDS.KM0,
    OFFER_TYPES_IDS.SUBSTITUTION,
    OFFER_TYPES_IDS.MANAGEMENT,
    OFFER_TYPES_IDS.DEMONSTRATION
  ],
  [LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.BUGGIES_NEW_VEHICLES]: [OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.BUGGIES_SECOND_HAND_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.BUGGIES_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND, OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.CLASSIC_AND_COMPETITION_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.CLASSIC_MOTOS_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.KM0_VEHICLES]: [
    OFFER_TYPES_IDS.KM0,
    OFFER_TYPES_IDS.NEW,
    OFFER_TYPES_IDS.SUBSTITUTION,
    OFFER_TYPES_IDS.MANAGEMENT,
    OFFER_TYPES_IDS.DEMONSTRATION
  ],
  [LISTING_SECTION_IDS.MINIMOTOS_NEW_VEHICLES]: [OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.MINIMOTOS_SECOND_HAND_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.MINIMOTOS_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND, OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.NEW_VEHICLES]: [OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.NO_LICENSE_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_NEW_VEHICLES]: [OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_SECOND_HAND_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND, OFFER_TYPES_IDS.NEW],
  [LISTING_SECTION_IDS.RENTING_VEHICLES]: [OFFER_TYPES_IDS.SUBSCRIPTION],
  [LISTING_SECTION_IDS.SECOND_HAND_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND],
  [LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES]: [OFFER_TYPES_IDS.SECOND_HAND]
}
